var Marionette = require('backbone.marionette');

var RelationCollection = require('../../collections/relations-collection');
var Relation = require('../../models/relation-model');
var PersonOrganizationModalView = require('./person-organization-modal-view');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');


var PersonOrganizationsItem = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/persons/person-organizations-item-view.html'),

    ui: {
        edit: '.person-org-edit',
        remove: '.person-org-remove'
    },

    events: {
        'click @ui.edit': 'onEdit',
        'click @ui.remove': 'onRemove'
    },

    templateContext: function () {
        var that = this;
        return {
            formatDate: that.getOption('formatDate'),
            canEdit: that.getOption('canEdit')
        }
    },

    initialize: function (options) {
    },

    onEdit: function () {
        this.triggerMethod('edit:person:org', this.model);
    },

    onRemove: function () {
        this.triggerMethod('remove:person:org', this.model);
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(4), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});


var PersonOrganizationsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PersonOrganizationsItem,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'edit:person:org': 'onEdit',
        'remove:person:org': 'onRemove'
    },

    initialize: function (options) {
        //_.bindAll(this, 'showLoading', 'hideLoading', 'logError');
        this.collection = options.collection;
        this.formatDate = options.formatDate;
        this.canEdit = options.canEdit;
    },

    childViewOptions: function () {
        return {
            formatDate: this.formatDate,
            canEdit: this.canEdit
        };
    },

    onEdit: function (model) {
        this.triggerMethod('edit:person:org', model);
    },

    onRemove: function (model) {
        this.triggerMethod('remove:person:org', model);
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    }
});

var PersonOrganizationsView = Marionette.View.extend({
    template: require('../../templates/persons/person-organizations-view.html'),

    regions: {
        modal: '#person-organization',
        tableBody: {
            el: 'tbody',
            replaceElement: true
        },
        removeConfirmationModal: '#person-org-delete-confirmation-modal'
    },

    ui: {
        newRelBtn: '#new-org'
    },

    events: {
        'click @ui.newRelBtn': 'newRelation'
    },

    collectionEvents: {
        error: 'logError'
    },

    childViewEvents: {
        'edit:person:org': 'onEdit',
        'remove:person:org': 'onRemove',
        'saved:person:organization': 'onSavedPersonOrganization',
        'action:confirmed': 'onRemoveConfirmed'
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit
        }
    },

    initialize: function (options) {
        this.personModel = options.personModel;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
    },

    onErrors: function (model, errors) {
        model.view.triggerMethod('server:error', errors.join('. \n'));
    },

    onRender: function () {
        var that = this;

        this.removeConfirmationModal = new YesNoConfirmationModal({
            tag: 'remove',
            message: "Are you sure you want to remove this relation?"
        });
        this.showChildView('removeConfirmationModal', this.removeConfirmationModal);

        that.collection = new RelationCollection([],
            {
                params: [
                    {key: 'systemRelationType', value: 'PERSON_ORGANIZATION'},
                    {key: 'parentId', value: that.personModel.id}
                ]
            });

        that.reloadCollection();
    },

    renderEditor: function (model, orgContacts, personContacts) {
        var excludedOrgsIds = this.collection.map(function (model) {
            return model.get("child").id;
        });

        this.personOrganizationModalView = new PersonOrganizationModalView({
            mode: "person",
            model: model,
            excludedOrgsIds: _.without(excludedOrgsIds, (model.get("child") || {}).id),
            orgContacts: orgContacts,
            personContacts: personContacts
        });
        this.showChildView('modal', this.personOrganizationModalView);
        this.personOrganizationModalView.show();
    },

    reloadCollection: function () {
        var that = this;
        that.showLoading();
        that.collection.fetch({
            success: function () {
                that.renderTable();
                that.hideLoading();
            },
            error: function () {
                that.hideLoading();
            }
        });
    },

    renderTable: function () {
        var that = this;
        that.showChildView('tableBody', new PersonOrganizationsTableBody({
            collection: that.collection,
            formatDate: function (dateAsLong) {
                return dateAsLong ? that.utils.longToDateTimeFormatted(dateAsLong, 'MMM DD YYYY') : "";
            },
            canEdit: that.canEdit
        }));
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    newRelation: function () {
        this.renderEditor(new Relation({
            systemRelationType: 'PERSON_ORGANIZATION',
            parentId: this.personModel.id,
            contacts: [],
            description: ""
        }), [], (this.personModel.get('object') || {}).contacts);
    },

    onSavedPersonOrganization: function () {
        this.reloadCollection();
    },

    onEdit: function (model) {
        var clonedModelAttributes = this.utils.deepClone(_.extend({}, model.attributes));
        var clonedModel = new Relation();
        clonedModel.set(clonedModelAttributes);
        this.renderEditor(clonedModel, clonedModelAttributes.child.object.contacts, (this.personModel.get('object') || {}).contacts);
    },

    onRemove: function (model) {
        this.modelToRemove = model;
        this.removeConfirmationModal.show();
    },

    onRemoveConfirmed: function (resp) {
        var that = this;
        if (resp.tag === 'remove' && resp.result == true) {
            that.modelToRemove.destroy({
                success: function (model, resp) {
                    that.reloadCollection();
                    that.removeConfirmationModal.hide();
                }
            });
        }
        else {
            that.removeConfirmationModal.hide();
        }
    }
});


module.exports = PersonOrganizationsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/person-organizations-view.js
// module id = 386
// module chunks = 0